import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const TreeDiagramIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M18.2 3C17.0059 3 15.9864 3.74745 15.5839 4.8H14.5C12.567 4.8 11 6.367 11 8.3V11H8.82929C8.41746 9.83481 7.30622 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15C7.30622 15 8.41746 14.1652 8.82929 13H11V15.7C11 17.633 12.567 19.2 14.5 19.2H15.5839C15.9864 20.2525 17.0059 21 18.2 21C19.7464 21 21 19.7464 21 18.2C21 16.6536 19.7464 15.4 18.2 15.4C17.0059 15.4 15.9864 16.1474 15.5839 17.2H14.5C13.6716 17.2 13 16.5284 13 15.7V13H15.5838C15.9864 14.0526 17.0059 14.8 18.2 14.8C19.7464 14.8 21 13.5464 21 12C21 10.4536 19.7464 9.20001 18.2 9.20001C17.0059 9.20001 15.9864 9.94746 15.5839 11H13V8.3C13 7.47157 13.6716 6.8 14.5 6.8H15.5839C15.9864 7.85255 17.0059 8.6 18.2 8.6C19.7464 8.6 21 7.3464 21 5.8C21 4.2536 19.7464 3 18.2 3ZM17.4 5.8C17.4 5.35817 17.7582 5 18.2 5C18.6418 5 19 5.35817 19 5.8C19 6.24183 18.6418 6.6 18.2 6.6C17.7582 6.6 17.4 6.24183 17.4 5.8ZM18.2 17.4C17.7582 17.4 17.4 17.7582 17.4 18.2C17.4 18.6418 17.7582 19 18.2 19C18.6418 19 19 18.6418 19 18.2C19 17.7582 18.6418 17.4 18.2 17.4ZM5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12ZM18.2 11.2C17.7582 11.2 17.4 11.5582 17.4 12C17.4 12.4418 17.7582 12.8 18.2 12.8C18.6418 12.8 19 12.4418 19 12C19 11.5582 18.6418 11.2 18.2 11.2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

TreeDiagramIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(TreeDiagramIcon);
